import React from 'react';
import {BackDropCMS} from '../backdrop/backdrop_cms';
import {Dialog} from 'material-ui';

export const EditDialog = React.forwardRef(function EditDialog(props, ref) {
    const {children, open, ...other} = props;

    /**
     * Note: disableEnforceFocus should be false for accessability reasons,
     * but has been set to true to allow tinymce to work correctly
     */
    return (
        <Dialog
            disableBackdropClick={true}
            BackdropComponent={BackDropCMS}
            maxWidth={false}
            open={open}
            fullWidth
            disableEnforceFocus={true}
            {...other}
        >
            {children}
        </Dialog>
    );
});



// WEBPACK FOOTER //
// ./src/components/edit-dialog/edit_dialog.js